<template>
  <BaseModal @close="$emit('close')">
    <template v-slot:title>Editar Estoque: {{ item.nome_recurso }}</template>
    <div class="modal-content-wrapper">
      <div class="stock-info">
        <span>Quantidade Atual:</span>
        <span class="estoque-badge">{{ item.quantidade }}</span>
      </div>
      <div class="form-group" style="margin-top: 20px;">
        <label>Definir Nova Quantidade:</label>
        <input v-model.number="novaQuantidade" type="number" class="estoque-input-modal" placeholder="Ex: 150" ref="inputEstoque" />
      </div>
      <div class="quick-fill-buttons">
        <button @click="ajustar(-10)">-10</button>
        <button @click="ajustar(10)">+10</button>
        <button @click="ajustar(50)">+50</button>
      </div>
    </div>
    <template v-slot:actions>
      <button @click="$emit('close')" class="modal-btn-no" :disabled="loading">Cancelar</button>
      <button @click="salvar" class="modal-btn-yes" :disabled="loading || novaQuantidade === '' || novaQuantidade < 0">{{ loading ? 'Salvando...' : 'Salvar' }}</button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '../BaseModal.vue';
import { AlertBus } from '@/plugins/AlertBus.js';

export default {
  name: 'ModalEstoqueForm',
  components: { BaseModal },
  props: {
    item: Object,
    loading: Boolean
  },
  data() {
    return {
      novaQuantidade: ''
    };
  },
  mounted() {
    this.novaQuantidade = this.item.quantidade;
    this.$nextTick(() => {
      setTimeout(() => { if(this.$refs.inputEstoque) this.$refs.inputEstoque.focus(); }, 50);
    });
  },
  methods: {
    ajustar(valor) {
      const atual = Number(this.novaQuantidade) || 0;
      this.novaQuantidade = Math.max(0, atual + valor);
    },
    salvar() {
      if (this.novaQuantidade === '' || this.novaQuantidade === null || isNaN(this.novaQuantidade)) {
        AlertBus.$emit('show-alert', { message: 'Insira um valor numérico.', type: 'alerta' });
        return;
      }
      this.$emit('save', { id: this.item.id, quantidade: this.novaQuantidade });
    }
  }
};
</script>

<style scoped>
/* Estilos copiados */
.modal-content-wrapper { padding: 5px 0; }
.stock-info { display: flex; justify-content: space-between; align-items: center; padding: 15px; background-color: var(--bg-main); border-radius: 6px; border: 1px solid var(--border-light); }
.estoque-badge { font-size: 1.1rem; font-weight: bold; color: var(--color-accent); padding: 5px 10px; background-color: var(--bg-main); border-radius: 4px; }
.estoque-input-modal { width: 100%; padding: 12px; border-radius: 4px; border: 1px solid var(--border-light); background-color: var(--bg-main); color: var(--text-main); font-size: 1.5rem; font-weight: bold; text-align: center; box-sizing: border-box; }
.estoque-input-modal:focus { outline: none; border-color: var(--color-accent); }
.quick-fill-buttons { display: flex; gap: 10px; margin: 15px 0 10px; }
.quick-fill-buttons button { flex: 1; background: var(--bg-icon-button); color: var(--text-main); border: 1px solid var(--border-light); padding: 10px; border-radius: 4px; cursor: pointer; font-weight: 600; transition: all 0.2s; }
.quick-fill-buttons button:hover { border-color: var(--color-accent); background-color: var(--bg-icon-button-hover); }
/* Reutilizar classes de botão do ModalProdutoForm ou colocar num global css se preferir */
.modal-btn-yes { background-color: #4caf50; color: white; padding: 10px 20px; border-radius: 5px; border: none; cursor: pointer; font-weight: bold; font-size: 1rem; }
.modal-btn-no { padding: 10px 20px; border-radius: 5px; border: none; cursor: pointer; font-weight: bold; font-size: 1rem; background-color: var(--bg-icon-button); color: var(--text-main); border: 1px solid var(--border-light); }
</style>